import {Component, Inject, OnInit, Optional} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MarketplaceManagerService} from 'src/app/services/marketplace-manager.service';
import {SharedFeaturesService} from 'src/app/services/shared-features.service';

@Component({
  selector: 'app-tenant-webchat-configuration',
  template: `
    <div class="wcd-head">
      <div class="wcd-t">Configure webchat</div>
      <div class="wcd-s">
        The webchat script is injected for this tenant's users.
      </div>
    </div>

    <form
      class="wcd-form"
      *ngIf="webChatForm"
      [formGroup]="webChatForm"
      (ngSubmit)="onSubmit()"
    >
      <div class="wcd-body">
        <div class="wcd-field">
          <label for="wcd-tenant">Tenant</label>
          <select id="wcd-tenant" formControlName="tenant">
            <option *ngFor="let tenant of tenantNames" [value]="tenant.name">
              {{ tenant?.name }}
            </option>
          </select>
        </div>
        <div class="wcd-field">
          <label for="wcd-url">Webchat build URL</label>
          <input
            id="wcd-url"
            type="text"
            formControlName="webchat_build_url"
            required
          />
        </div>
        <div class="wcd-field last">
          <label for="wcd-bot">Bot name</label>
          <input id="wcd-bot" type="text" formControlName="bot_name" required />
        </div>
      </div>

      <div class="wcd-foot">
        <button
          type="button"
          class="btn-ghost"
          mat-dialog-close
          *ngIf="dialogRef"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn-primary"
          [disabled]="webChatForm.invalid"
        >
          {{ data ? 'Update webchat' : 'Save webchat' }}
        </button>
      </div>
    </form>
  `,
  styleUrls: ['./tenant-webchat-configuration.component.scss'],
})
export class TenantWebchatConfigurationComponent implements OnInit {
  webChatForm: FormGroup | any;

  tenantNames: any = [];

  constructor(
    private formBuilder: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private marketPlaceManagerServices: MarketplaceManagerService,
    @Optional()
    public dialogRef: MatDialogRef<TenantWebchatConfigurationComponent> | null,
    private sharedServices: SharedFeaturesService
  ) {
  }

  ngOnInit(): void {
    this.webChatForm = this.formBuilder.group({
      webchat_build_url: ['', Validators.required],
      bot_name: ['', Validators.required],
      tenant: ['', Validators.required],
    });
    if (this.data) {
      this.webChatForm.patchValue({
        webchat_build_url: this.data.webchat_build_url || '',
        bot_name: this.data.bot_name || '',
        tenant: this.data.tenant || '',
      });
    }
    this.marketPlaceManagerServices.getAvailableTenant().subscribe({
      next: (response: any) => {
        this.tenantNames = response?.msg;
      },
      error: (error: any) => {
        console.error('An error occurred', error);
      },
    });
  }

  onSubmit() {
    if (this.webChatForm.valid) {
      this.dialogRef?.close(this.webChatForm.value);
    } else {
      this.sharedServices.openSnackBar(
        'Invalid Data',
        'Close',
        'error-snackbar'
      );
    }
  }
}
